import { VueExtension } from '../../utils/extensions/vue';
import Popup from './popup.jsx';
import './popup.scss';

VueExtension.WithInstall(Popup);

export default Popup;
